import { Routes as Rotas, Route } from 'react-router-dom';
import Layout from '../layout/mainLayout';
import Arrecadacao from 'pages/Arrecadacao';
import Login from 'pages/Login/Login';
import Logout from 'pages/Logout/Logout';
import HeaderFooterLayout from 'layout/headerFooterLayout';
import TitularArrendatarioEdit from 'pages/TitularArrendatario/TitularArrendatarioEdit/TitularArrendatarioEdit';
import PrimeiroAdquirenteEdit from 'pages/PrimeiroAdquirente/PrimeiroAdquirenteEdit/PrimeiroAdquirenteEdit';

const Routes = () => {
  return (
    <Rotas>
      <Route element={<HeaderFooterLayout />}>
        <Route path='login' element={<Login />} />
        <Route element={<Layout />}>
          <Route index element={<Arrecadacao />} />
          <Route path='logout' element={<Logout />} />
          <Route path='titular-ou-arrendatario' element={<TitularArrendatarioEdit />} />
          <Route path='titular-ou-arrendatario-view' element={<TitularArrendatarioEdit stepProp={5} />} />
          <Route path='primeiro-adquirente' element={<PrimeiroAdquirenteEdit />} />
          <Route path='primeiro-adquirente-view' element={<PrimeiroAdquirenteEdit stepProp={5} />} />
        </Route>
      </Route>
    </Rotas>
  );
};

export default Routes;
